import AppHeader from '../AppHeader'
import { mapGetters } from 'vuex'

export default {
  name: 'propose',
  created () {
    window.sessionStorage.clear() // 検索条件クリア
    this.getUnapprovedCount()
    this.getApprovedCount()
  },
  data () {
    return {
      unapprovedCount: 0,
      approvedCount: 0
    }
  },
  components: {
    AppHeader
  },
  computed: {
    ...mapGetters([
      'isSystemManagement'
    ])
  },
  methods: {
    getUnapprovedCount: function () {
      const data = {'status': 'unapproved'}
      this.$store.dispatch('PROPOSE_COUNT', {data: data, callback: this.setUnapprovedCount})
    },
    getApprovedCount: function () {
      const data = {'status': 'approved'}
      this.$store.dispatch('PROPOSE_COUNT', {data: data, callback: this.setApprovedCount})
    },
    setUnapprovedCount: function (data) {
      this.unapprovedCount = data
    },
    setApprovedCount: function (data) {
      this.approvedCount = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose.js